// this component should have a 2 inputs selection for state and local government and when you select the state the local government should be filtered based on the state selected and should have an array of all the states and local governments in nigeria , but now i should fewer states and local governments for testing purpose, the component should MUI select component with the same styling as the other components in the project with the same functionality as the other components in the project, list the states and local governments in array in this file
import React, { useState, useContext, useEffect } from "react";
import { TextField, MenuItem, Button } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import { ContextData } from "../../../../../context/Context";
import baseUrl from "../../../../../BaseURL";
import { StateListAndLGAs } from "./StateListAndLGAs";


const statesAndLGAs = {
  "Lagos": ["Ikeja", "Epe", "Ikorodu", "Surulere"],
  "Kano": ["Nassarawa", "Fagge", "Gwale", "Dala"],
  "Rivers": ["Port Harcourt", "Obio-Akpor", "Okrika", "Bonny"],
  "Kaduna": ["Zaria", "Kafanchan", "Saminaka", "Birnin Gwari"]
};

export default function StateList({formData,setFormData}) {

    //state_of_location
//local_government
  const { user } = useContext(ContextData);
  const [localGovernments, setLocalGovernments] = useState([]);

  useEffect(() => {
    if (formData.state_of_location) {
      setLocalGovernments(StateListAndLGAs[formData.state_of_location]);
    } else {
      setLocalGovernments([]);
    }

     if(formData.state_of_location !== "other"){
        setFormData({
        ...formData,
        other_institution: ""
      })
      setFormData({
        ...formData,
        other_institution: "N/A"
      })
     }else{
      setFormData({
        ...formData,
        other_institution: ""
      })
     }
  }, [formData.state_of_location]); 

  const handleChange = (e) => {

    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      ...(name === "state_of_location" && { local_government: "" }) // Reset local government if state changes
    });

  };



  return (
    <div className="space-y-4 text-left">
      <TextField
        select
        label="State"
        name="state_of_location"
        value={formData.state_of_location}
        onChange={handleChange}
        fullWidth
        required
        variant="outlined"
      >
        {Object.keys(StateListAndLGAs).map((state) => (
          <MenuItem key={state} value={state}>{state}</MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label="Local Government"
        name="local_government"
        value={formData.local_government}
        onChange={handleChange}
        fullWidth
        required
        variant="outlined"
        disabled={!formData.state_of_location}
      >
        {localGovernments.map((lga) => (
          <MenuItem key={lga} value={lga}>{lga}</MenuItem>
        ))}
      </TextField>
      
    </div>
  );
}   